import axios from "../../axios";
import {
  GET_STAFF_LIST, GET_SERVICE_LIST, GET_STAFF_SERVICE_LIST, ADD_STAFF, UPDATE_STAFF, DELETE_STAFF, GET_WORKING_HOUR, UPDATE_WORKING_HOUR,
  ADD_SERVICE_TO_STAFF, REMOVE_SERVICE_FROM_STAFF, GET_CHECKIN_STAFF, UPDATE_BOOKING_STAFF, DRAG_STAFF, CHANGE_STAFF_COMMISSION, LIST_COMMISSION_BY_STAFF,
  UPDATE_COMMISION, GET_PERMISSION_LIST
} from "./staffListTypes";
import {
  URL_GET_STAFF_LIST, URL_GET_SERVICE_LIST, URL_GET_STAFF_SERVICE_LIST, URL_ADD_STAFF, URL_UPDATE_STAFF, URL_DELETE_STAFF, URL_GET_WORKING_HOUR, URL_UPDATE_WORKING_HOUR,
  URL_ADD_SERVICE_TO_STAFF, URL_REMOVE_SERVICE_FROM_STAFF, UPDATE_BOOKING_STAFF_URL, URL_DRAG_STAFF, URL_CHANGE_STAFF_COMMISSION, URL_LIST_COMMISSION_BY_STAFF,
  URL_UPDATE_COMMISION, URL_GET_PERMISSION_LIST
} from "./staffListUrl";
import store from '../store'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'

export default {
  [GET_STAFF_LIST]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_STAFF_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STAFF_LIST, data);
              resolve(data);
            } else {
              commit(GET_STAFF_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_STAFF_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          // //   commit(GET_STAFF_LIST,{items: [], _links: {}, _meta: {}});
          // //   resolve({items: [], _links: {}, _meta: {}})
          // // }else{
          //   commit(GET_STAFF_LIST, response.data.result.data);
          //   resolve(response.data.result.data)
          // } else {
          //   commit(GET_STAFF_LIST, {items: [], _links: {}, _meta: {}});
          //   resolve({items: [], _links: {}, _meta: {}});
          // }
        })
        .catch((error) => { reject(error) })
    })
  },
  [GET_CHECKIN_STAFF]({ commit }, data) {
    commit(GET_CHECKIN_STAFF, data);
  },

  [DRAG_STAFF]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DRAG_STAFF}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page: item.page,
                'per-page': item['per-page']
              }
              dispatch(GET_STAFF_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [ADD_STAFF]({ commit }, item) {
    return new Promise((resolve, reject) => {
      // let param = new URLSearchParams(item).toString();
      // let data = new FormData();
      // for (var key in item) {
      //   data.append(key, item[key]);
      // }
      axios.post(`${URL_ADD_STAFF}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  [UPDATE_STAFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      // let data = new FormData();
      // for (var key in item) {
      //   data.append(key, item[key]);
      // }
      let data = JSON.parse(JSON.stringify(item));
      delete data.filter
      axios.post(`${URL_UPDATE_STAFF}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page: item.page,
                'per-page': item['per-page'],
                // status: item.filter
                sort: 'user_id'
              }
              if (item.filter != 2) {
                temp.status = item.filter
              }
              dispatch(GET_STAFF_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [DELETE_STAFF]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_DELETE_STAFF}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // delete item.id;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if (response.data.result.status == "FAIL") {
          //   reject(response.data.result.message.code[0])
          // }
          // else {
          //   delete item.id
          //   resolve(response.data);
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_WORKING_HOUR]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_GET_WORKING_HOUR}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_WORKING_HOUR, data);
              resolve(data);
            } else {
              commit(GET_WORKING_HOUR, {});
              // reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // }
          // else {
          //   commit(GET_WORKING_HOUR, response.data.result.data);
          //   resolve(response.data.result.data);
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_WORKING_HOUR]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      let param = new URLSearchParams({ id: item.id }).toString();
      axios.post(`${URL_UPDATE_WORKING_HOUR}${param}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_WORKING_HOUR, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // } else {
          //   dispatch('GET_WORKING_HOUR', item);
          //   resolve(response.data.result.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_SERVICE_LIST]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SERVICE_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SERVICE_LIST, data);
              resolve(data);
            } else {
              commit(GET_SERVICE_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_SERVICE_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.status !== 'FAIL') {
          // //   reject(response.data.message);
          // // }
          // // else {
          //   commit(GET_SERVICE_LIST, response.data.result.data);
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_STAFF_SERVICE_LIST]({ commit }, item) {
    item = {
      ...item,
      "per-page": 100
    }
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_STAFF_SERVICE_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STAFF_SERVICE_LIST, data);
              resolve(data);
            } else {
              commit(GET_STAFF_SERVICE_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_STAFF_SERVICE_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.status !== 'FAIL') {
          // //   commit(GET_STAFF_SERVICE_LIST, []);
          // // }
          // // else {
          //   commit(GET_STAFF_SERVICE_LIST, response.data.result.data);
          //   resolve(response.data)
          // } else {
          //   commit(GET_STAFF_SERVICE_LIST, {items: [], _links: {}, _meta: {}});
          //   resolve({items: [], _links: {}, _meta: {}})
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [ADD_SERVICE_TO_STAFF]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_SERVICE_TO_STAFF}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                id: item.staff_id
              }
              dispatch(GET_STAFF_SERVICE_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // } else {
          //   let temp = {
          //     id: item.staff_id
          //   }
          //   dispatch("GET_STAFF_SERVICE_LIST", temp);
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [REMOVE_SERVICE_FROM_STAFF]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    // let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.post(`${URL_REMOVE_SERVICE_FROM_STAFF}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                id: item.staff_id
              }
              dispatch(GET_STAFF_SERVICE_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // } else {
          //   let temp = {
          //     id: item.staff_id
          //   }
          //   dispatch("GET_STAFF_SERVICE_LIST", temp);
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_BOOKING_STAFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(UPDATE_BOOKING_STAFF_URL, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page: item.page,
                'per-page': item['per-page'],
                sort: 'user_id'
              }
              if (item.filter != 2) {
                temp.status = item.filter
              }
              dispatch(GET_STAFF_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  // eslint-disable-next-line
  [CHANGE_STAFF_COMMISSION]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      // delete data.filter
      axios.post(`${URL_CHANGE_STAFF_COMMISSION}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if(item.id && item.detail_filter_days) {
                dispatch(LIST_COMMISSION_BY_STAFF, {staff_id: item.id});
                // setTimeout(() => {
                  // let temp = {
                  //   staff_id: item.id,
                  //   start_date: item.detail_filter_days.start_date,
                  //   end_date: item.detail_filter_days.end_date
                  // }
                  // store.dispatch('goPos/GET_INCOME_DETAIL', temp);
                // }, 5000);
              } else {
                let temp = {
                  page: item.page,
                  'per-page': item['per-page'],
                  sort: 'user_id'
                }
                if (item.filter != 2) {
                  temp.status = item.filter
                }
                dispatch(GET_STAFF_LIST, temp);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [LIST_COMMISSION_BY_STAFF]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_LIST_COMMISSION_BY_STAFF}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(LIST_COMMISSION_BY_STAFF, data);
              resolve(data);
            } else {
              commit(LIST_COMMISSION_BY_STAFF, {});
              resolve({});
            }
          } else {
            commit(LIST_COMMISSION_BY_STAFF, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [UPDATE_COMMISION]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_COMMISION}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_PERMISSION_LIST]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_GET_PERMISSION_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PERMISSION_LIST, data);
              resolve(data);
            } else {
              commit(GET_PERMISSION_LIST, []);
              // reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
}
